module.exports = __webpack_public_path__ + "static/media/stackUsingArray.2baeab32.c";